<template>
    <div class="is-flex is-justify-content-flex-end">
        <div class="pr-5 tag-size">
            <b-tag
                v-if="item.situacao == 1"
                type="is-success"
                size="is-medium"
            >
                {{ $t("ativo") }}
            </b-tag>
            <b-tag
                v-else
                type="is-danger"
                size="is-medium"
            >
                {{ $t("inativo") }}
            </b-tag>
        </div>
        <div v-if="canDelete">
            <b-button
                class="action-button"
                :type="item['situacao'] == 1 ? 'is-danger' : 'is-success'"
                :icon-right="item['situacao'] == 1 ? 'delete' : 'check'"
                @click="promptChangeSituacao()"
                v-tippy 
                :title="$t(item['situacao'] == 1 ? 'desativar' : 'reativar')"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // Service com metodo updateSituacao para fazer a requisição de mudar a situação
        service: Object,
        // Nome do registro na pagina
        record: String,
        // Item da tabela que está sendo passado
        item: Object,
        // Identificador desse item para a construção das menssagem
        identifier: String,
        // Permissões
        canDelete: Boolean,
        rotaIntegracao: Boolean,
    },
    data: {
        delete: Object,
    },
    methods: {
        promptChangeSituacao() {
            let message = this.$t(
                    this.item.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: this.identifier }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
            });
        },
        updateSituacao() {
            this.delete = this.item;
            this.delete.situacao = this.delete.situacao == 1 ? 0 : 1;

            this.$store.commit('addLoader')

            this.service
                .updateSituacao(this.delete)
                .then((r) => {
                    if (r.status == 200) {
                        let messageSuccess = this.$t(
                                r.content.situacao != 1
                                    ? "msg-sucesso-ao-desativar"
                                    : "msg-sucesso-ao-reativar", 
                                { n: this.$t(this.record) }
                            );

                        this.$root.showMessage(
                            "success",
                            messageSuccess,
                            true,
                            false
                        );
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);

                    let messageFail = this.$t(
                            this.delete.situacao != 1
                                ? "msg-erro-ao-desativar"
                                : "msg-erro-ao-reativar", 
                            { n: this.record }
                        );

                    this.$root.showMessage("error", messageFail, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                    this.$store.commit('removeLoader');
                    this.$emit('loadData');
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.tag-size {
    .tag {
        width: 5rem;
        height: 3em;
    }
}
</style>
